import React from 'react'

const Twitter: React.FC  = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-labelledby="svg847ca3f0-5b64-474e-b5f3-411365f893b6"><title id="svg847ca3f0-5b64-474e-b5f3-411365f893b6">Twitter</title><g><path d="M4.03948 4L10.2162 12.8251L4 20H5.39938L10.8411 13.7185L15.2387 20H20L13.4756 10.6792L19.2619 4.00114H17.8625L12.8506 9.7869L8.80073 4.00114H4.03948V4ZM6.09695 5.10085H8.28451L17.9425 18.898H15.7549L6.09695 5.10085Z" fill="black"></path></g></svg>
  )
}

export default Twitter